const $ = jQuery.noConflict();
import PerfectScrollbar from 'perfect-scrollbar';

'use strict';
const PSB = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	selectorStyleguideNav: '.js-styleguide-nav-list-holder',
	classHide: 'hideFade',
	$domSideNavItem: $('.js-product-listing__side-nav-item a'),
	classProductListingSideNav: '.js-product-listing__side-nav',
	$domSearchFormOptions: $('.js-search-filter__body-top-options--with-img, .js-product-listing__header-options--with-img'),
	$domAddToListPopUp: $('.js-product-info-box__add-list-wrapper'),
	$domSalesmanWrap: $('.js-sales-wrap'),
	strPopupOrder: '.js-popup-table',

	/** @description Initialize */
	init: ()=> {
		PSB.perfectScrollBarStyleguide();
		// $('.select2-container').on("click", function () {
		// 	PSB.perfScroll('.select2-results__options');
		// });
		setTimeout(() => {
			if ($('.js-product-listing__side-nav').length) {
				PSB.ProductListingSideNav();
			}

			if ($('.js-sales-wrap').length) {
				PSB.perfScroll('.js-sales-wrap');
			}

			if ($('.js-search-suggestions').length) {
				PSB.perfScroll('.js-search-suggestions');
			}

			if ($('.js-header-search__wrapper-categories-wrapper').length) {
				PSB.perfScroll('.js-header-search__wrapper-categories-wrapper');
			}

			if ($('.js-popup-table').length) {
				PSB.perfScroll(PSB.strPopupOrder);
			}

		}, 2000);
	},

	/**
	 * @description Stylequide scrollbar
	 */
	perfectScrollBarStyleguide: () => {
		$(PSB.selectorStyleguideNav).each((i, el)=> {
			const selector = $(el)[0];

			const ps = new PerfectScrollbar(selector, {
				wheelSpeed: 1,
				suppressScrollX: true,
				minScrollbarLength: 20
			});

			selector.addEventListener('ps-scroll-y', (e) => {
				const _self = $(e.currentTarget);
				const reach = ps.reach.y;

				reach === 'end' ? _self.parent().addClass(PSB.classHide) : _self.parent().removeClass(PSB.classHide);
			});
		});
	},

	ProductListingSideNav: () => {
		if ($(window).width() > 1024) {
		$(PSB.classProductListingSideNav).each((i, el)=> {
			const selector = $(el)[0];

			const ps = new PerfectScrollbar(selector, {
				wheelSpeed: 1,
				wheelPropagation: true,
				minScrollbarLength: 20,
				useBothWheelAxes: false,
				suppressScrollX: true,
			});

			selector.addEventListener('click', () => {
				ps.update();
			});

			selector.addEventListener('mouseenter', () => {
				ps.update();
				console.log('mouseenter');
			});

			selector.addEventListener('mouseleave', () => {
				ps.update();
				console.log('mouseleave');
			});
		});
	}
	},

	perfScroll: function($selector) {
		$($selector).each((i, el)=> {
			const selector = $(el)[0];

			const ps = new PerfectScrollbar(selector, {
				wheelSpeed: 1,
				wheelPropagation: true,
				minScrollbarLength: 20,
				useBothWheelAxes: false,
				suppressScrollX: true,
			});

			setTimeout(() => {
				ps.update();
			}, 100);
		});
	},
};

export default PSB;
